import type { IRoofMeasurementsForm, RoofMeasurementKey } from "../interfaces/IRoofMeasurement";

export const ROOF_MEASUREMENT_TYPES: ReadonlyArray<{
    key: RoofMeasurementKey;
    label: string;
    unit: string;
}> = [
    { key: "Area", label: "Area", unit: "SQ" },
    { key: "Ridge", label: "Ridge", unit: "LF" },
    { key: "Hip", label: "Hip", unit: "LF" },
    { key: "Valley", label: "Valley", unit: "LF" },
    { key: "Eave", label: "Eave", unit: "LF" },
    { key: "Rake", label: "Rake", unit: "LF" },
    { key: "Roll Valley", label: "Roll Valley", unit: "LF" },
    { key: "CounterFlashing", label: "Counter Flashing", unit: "LF" },
    { key: "StepFlashing", label: "Step Flashing", unit: "LF" },
];

export const ROOF_MEASUREMENT_KEYS: RoofMeasurementKey[] = ROOF_MEASUREMENT_TYPES.map(
    (item) => item.key,
);

export function buildEmptyMeasurements(): IRoofMeasurementsForm {
    return ROOF_MEASUREMENT_KEYS.reduce((acc, key) => {
        acc[key] = { Calculated: 0, Actual: 0 };
        return acc;
    }, {} as IRoofMeasurementsForm);
}

export function isRoofMeasurementKey(key: string): key is RoofMeasurementKey {
    return (ROOF_MEASUREMENT_KEYS as readonly string[]).includes(key);
}
